module.exports = __webpack_public_path__ + "static/img/pixsix.ee799ff9.png";